import type { CreateWorkPlacementInput } from '@duke-hq/svc-api/admin/trpc/routers/workPlacements/placements/schemas';
import type { PlacementDetailsState } from './types';

export function buildPayload(
  courseEnrolmentId: number,
  contractId: string,
  details: PlacementDetailsState,
): CreateWorkPlacementInput {
  return {
    courseEnrolmentId,
    contractId,
    agreementFileDrns: details.agreement != null ? [details.agreement.drn] : [],
    startedAt: details.startedAt !== '' ? details.startedAt : undefined,
    notes: details.notes.trim() !== '' ? details.notes.trim() : undefined,
  };
}
